module.exports = __webpack_public_path__ + "img/04.ce9fd15f.png";